import { getEnv } from "@/utils";
import APIAbstract from "./apiAbstract";

export default class UserApi extends APIAbstract {
  constructor() {
    super({
      baseUrl: `${getEnv("treebalApiUrlUser", "notSet")}`,
      basePath: "api/v1/user",
    });
  }
}
